import { ServiceClient } from 'src/utils'

const serviceClient = ServiceClient.singleton()

export type ReleaseNotesStatus = {
    unreadCount: number
    pageUrl: string
}

export class ReleaseNotesService {
    static #INSTANCE = new ReleaseNotesService()
    static readonly singleton = () => ReleaseNotesService.#INSTANCE

    async fetchStatus(): Promise<ReleaseNotesStatus> {
        return serviceClient.authGet<ReleaseNotesStatus>('/api/release-notes/status')
    }

    async markAsRead(): Promise<void> {
        await serviceClient.authPost('/api/release-notes/mark-as-read')
    }
}

export default ReleaseNotesService.singleton()
